<template>
    <v-container class="hkiarace-home-page-setting" v-if="homePage">
        <v-row>
            <v-col>
                <h2>{{$t('admin_home_page.title')}}</h2>
            </v-col>
        </v-row>
        <hr>
        <v-row class="hkiarace-home-page-title">
            <v-col>
                {{$t('admin_home_page.upcoming_events')}}
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-data-table show-select
                              :items="events"
                              :headers="eventHeaders"
                              v-model="selectedEventsForCarousel">
                    <template v-slot:item.name_en="{value}">
                        <span v-html="value"></span>
                    </template>
                    <template v-slot:item.name_zh="{value}">
                        <span v-html="value"></span>
                    </template>
                </v-data-table>
            </v-col>
        </v-row>

        <v-divider></v-divider>

        <v-row>
            <v-col>
                <v-data-table show-select
                              :items="itemTypes"
                              :headers="itemTypeHeaders"
                              v-model="selectedItemTypes">
                </v-data-table>
            </v-col>
        </v-row>
        <b-button id="saveHomePageBtn" @click="saveHomePage" variant="primary">{{$t('save')}}</b-button>
    </v-container>
</template>

<script>
    export default {
        name: 'HkiaraceHomePageSetting',
        data() {
            return {
                homePage: null,
                events: [],
                eventHeaders: [
                    {value: 'name_en', text: this.$t('admin_event.name_en')},
                    {value: 'name_zh', text: this.$t('admin_event.name_zh')},
                    {value: 'category.name', text: this.$t('admin_event.category')},
                ],
                selectedEventsForCarousel: [],

                itemTypes: [],
                itemTypeHeaders: [
                    {value: 'name_en', text: this.$t('admin_acc_facility_type.name_en')},
                    {value: 'name_zh', text: this.$t('admin_acc_facility_type.name_zh')},
                ],
                selectedItemTypes: [],
            }
        },
        mounted() {
            this.getHomePage();
            this.getItemTypes();
            this.getEvents();
        },
        methods: {
            getHomePage() {
                this.$callAPI('hkiarace/admin/home_page/', {}, function (response) {
                    this.homePage = response.body;

                    this.selectedEventsForCarousel = response.body.banner_events;
                    this.selectedItemTypes = response.body.hot_items;
                })
            },
            getItemTypes() {
                this.$callAPI('aafb/admin/item_type/', {}, function (response) {
                    this.itemTypes = response.body.item_types;
                })
            },
            getEvents() {
                this.$callAPI('hkiarace/admin/event/', {}, function (response) {
                    this.events = response.body.events;
                })
            },
            saveHomePage() {
                let params = {
                    banner_events: this.selectedEventsForCarousel.map((e) => e.id),
                    hot_items: this.selectedItemTypes.map((t) => t.id),
                };

                this.$callAPI('hkiarace/admin/home_page/set/', params, function (response) {
                    this.$showAlertMessage('Saved Successfully');
                    this.getHomePage();
                });
            },
        },
    }
</script>

<style scoped lang="less">
    .hkiarace-home-page-setting {
        .hkiarace-home-page-title {
            font-size: 1.75rem;
        }

        .photo-preview {
            /*height: 150px;*/

            .photo-preview-remove-btn {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                background-color: rgba(0, 0, 0, 0.5);
                opacity: 0;
                cursor: pointer;
                transition: opacity 0.3s;

                &:hover {
                    opacity: 1;
                    transition: opacity 0.3s;
                }

                .fa-times {
                    color: white;
                    height: 50%;
                    width: 50%;
                    position: absolute;
                    left: 25%;
                    top: 25%;
                }
            }
        }
    }
</style>
